import { render, staticRenderFns } from "./star.vue?vue&type=template&id=5d16ce88&"
import script from "./star.vue?vue&type=script&lang=js&"
export * from "./star.vue?vue&type=script&lang=js&"
import style0 from "./star.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d16ce88')) {
      api.createRecord('5d16ce88', component.options)
    } else {
      api.reload('5d16ce88', component.options)
    }
    module.hot.accept("./star.vue?vue&type=template&id=5d16ce88&", function () {
      api.rerender('5d16ce88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-stats/star.vue"
export default component.exports